export const tableTypesMatcher = value => {
  switch (value) {
    case 'american':
      return 'Américain'
    case 'pool':
      return 'Pool'
    case 'snooker':
      return 'Snooker'
    case 'carom':
      return 'Carambole'
    case 'chinese':
      return 'Chinese'
    default:
      return 'Unknown'
  }
}
export const pricingTypesShortMatcher = value => {
  switch (value) {
    case 0:
      return '€/heure'
    case 1:
      return '€/joueur'
    default:
      return '?'
  }
}
export const pricingTypesMatcher = (value, longName) => {
  switch (value) {
    case 0:
      return `Tarif Horaire ${longName ? '(€/heure)' : ''}`
    case 1:
      return `Tarif Fixe ${longName ? '(€/joueur)' : ''}`
    default:
      return '?'
  }
}



// WEBPACK FOOTER //
// ./src/utils/labelMatcher.js